import { useAuth, usePost } from '@selfserve/react-hooks';
import { apiEndpoints } from '@selfserve/react-utils';

export interface LoginForUpgradeRequest {
  productFamily: string;
  ks: string;
}

export const useLoginForUpgrade = () => {
  const { setHasAccessToken } = useAuth();
  return usePost<LoginForUpgradeRequest, any>(apiEndpoints.loginForUpgrade, undefined, {
    // loginForUpgrade sets an httpOnly access_token cookie - remember it for later visits without a ks
    onSuccess: (res: { status: number }) => {
      if (res.status >= 200 && res.status < 300) {
        setHasAccessToken(true);
      }
    },
  });
};
